<template>
  <va-delete-button
    :resource="listState.resource"
    plain
    :showIcon="true"
    :label="$t('overrides.actions.delete') + ` (${listState.selected.length})`"
    color="primary"
    @delete="onBulkDelete"
  ></va-delete-button>
</template>

<script>
/**
 * Button for delete bulk actions for VaList. Shown after items selections.
 * Keep all VaDeleteButton feature and use `deleteMany` data provider method under the hood.
 */
export default {
  inject: {
    listState: { default: undefined },
  },
  props: {
    /**
     * Selected resources items.
     */
    value: Array,
  },
  computed: {
    currentResource() {
      return this.$admin.getResource(this.listState.resource);
    },
  },
  methods: {
    async onBulkDelete() {
      let value = this.value || this.listState.selected;

      this.$store.dispatch(`${this.listState.resource}/displayDeleteModal`, {
        displayDeleteModal: true,
        items: value,
        itemsList: this.listState.items,
        postDeleteCallback: () => {
          /**
           * Cleanup selected elements
           */
          this.$emit("input", []);
          this.listState.selected = [];
          this.$store.dispatch("api/refresh", this.listState.resource);
          this.$admin.toast.success(
            this.$t("generic.resource_deleted_successfully", {
              resource:
                value.map(({ id }) => id).length > 1
                  ? this.currentResource.pluralName
                  : this.currentResource.singularName,
            })
          );
        },
      });
    },
  },
};
</script>
